if (!customElements.get('quantity-popover')) {
  let quantityPopoverId = 0;
  customElements.define(
    'quantity-popover',
    class QuantityPopover extends HTMLElement {
      constructor() {
        super();
        this.mql = window.matchMedia('(min-width: 990px)');
        this.infoButtonDesktop = this.querySelector('.quantity-popover__info-button--icon-only');
        this.infoButtonMobile = this.querySelector('.quantity-popover__info-button--icon-with-label');
        this.popoverInfo = this.querySelector('.quantity-popover__info');
        this.closeButton = this.querySelector('.button-close');
        this.eventMouseEnterHappened = false;
        this.initializeAccessibility();
        this.addEventListener('keyup', event => {
          if (event.key !== 'Escape' || !this.popoverInfo || this.popoverInfo.hidden) return;
          event.stopPropagation();
          this.closePopover(event);
        });
        this.addEventListener('focusout', event => {
          if (event.relatedTarget && !this.contains(event.relatedTarget)) this.closePopover(event);
        });

        if (this.closeButton) {
          this.closeButton.addEventListener('click', this.closePopover.bind(this));
        }

        if (this.popoverInfo && this.infoButtonDesktop) {
          this.popoverInfo.addEventListener('mouseleave', this.closePopover.bind(this));
        }

        if (this.infoButtonDesktop) {
          this.infoButtonDesktop.addEventListener('click', this.togglePopover.bind(this));
        }

        if (this.infoButtonMobile) {
          this.infoButtonMobile.addEventListener('click', this.togglePopover.bind(this));
        }

        if (this.infoButtonDesktop) {
          this.infoButtonDesktop.addEventListener('mouseenter', this.togglePopover.bind(this));
          this.infoButtonDesktop.addEventListener('mouseleave', this.closePopover.bind(this));
        }
      }

      connectedCallback() {
        this.initializeAccessibility();
      }

      initializeAccessibility() {
        if (!this.popoverInfo) return;
        const existingPanel = this.popoverInfo.id && document.getElementById(this.popoverInfo.id);
        if (!this.popoverInfo.id || (existingPanel && existingPanel !== this.popoverInfo)) {
          let panelId;
          do { panelId = `QuantityPopover-${++quantityPopoverId}`; } while (document.getElementById(panelId));
          this.popoverInfo.id = panelId;
        }
        [this.infoButtonDesktop, this.infoButtonMobile].forEach(button => {
          button?.setAttribute('aria-controls', this.popoverInfo.id);
        });
        if (this.infoButtonDesktop && !this.infoButtonDesktop.hasAttribute('aria-label')) {
          const label = this.infoButtonMobile?.textContent.trim();
          if (label) this.infoButtonDesktop.setAttribute('aria-label', label);
        }
        this.setExpanded(!this.popoverInfo.hidden);
      }

      togglePopover(event) {
        if (event.type === 'mouseenter' && !this.mql.matches) return;
        event.preventDefault();
        if (event.type === 'mouseenter') {
          this.eventMouseEnterHappened = true;
        }

        if (event.type === 'click' && event.detail > 0 && this.eventMouseEnterHappened) return;

        const button = event.currentTarget;
        const isExpanded = !this.popoverInfo.hidden;

        if ((this.mql.matches && !isExpanded) || event.type === 'click') {
          this.setExpanded(!isExpanded);
        }

        const isOpen = !this.popoverInfo.hidden;

        if (isOpen && event.type !== 'mouseenter') {
          button.focus();
        }
      }

      closePopover(event) {
        if (!this.popoverInfo) return;
        if (event.type === 'mouseleave' && this.popoverInfo.contains(document.activeElement)) return;
        event.preventDefault();
        if (!event.relatedTarget || !this.contains(event.relatedTarget)) {
          if (event.type === 'click' || event.key === 'Escape') {
            const button = this.mql.matches
              ? this.infoButtonDesktop || this.infoButtonMobile
              : this.infoButtonMobile || this.infoButtonDesktop;
            button?.focus();
          }
          this.setExpanded(false);
        }

        this.eventMouseEnterHappened = false;
      }

      setExpanded(expanded) {
        this.popoverInfo.hidden = !expanded;
        [this.infoButtonDesktop, this.infoButtonMobile].forEach(button => {
          button?.setAttribute('aria-expanded', String(expanded));
          button?.classList.toggle('quantity-popover__info-button--open', expanded);
        });
        this.infoButtonDesktop?.classList.toggle('quantity-popover__info-button--icon-only--animation', expanded);
      }
    }
  );
}
